module.exports = __webpack_public_path__ + "img/二维码_肇庆.2b6b88d9.png";